// extracted by mini-css-extract-plugin
export var container = "_il-0";
export var content = "_il-3";
export var customerTitle = "_il-4";
export var empty = "_il-5";
export var gray = "_il-6";
export var header = "_il-7";
export var info = "_il-8";
export var loading = "_il-2";
export var loadingCard = "_il-9";
export var oneLine = "_il-a";
export var personName = "_il-e";
export var pillContainer = "_il-b";
export var selected = "_il-1";
export var text = "_il-c";
export var twoLines = "_il-d";
export var unread = "_il-f";
export var unreadIndicator = "_il-g";